<template>
  <div class="select-chain">
    <!-- 最优交易路径显示 -->
    <div class="trade-path" v-if="!isPopupMode">
      <span class="label">最优交易路径</span>
      <div class="trade-path-rt" @click="showChainPopup" v-if="selectedPath">
        <img class="logo" :src="selectedPath.imageUrl" alt="">
        <span>{{ selectedPath.symbol }}</span>
        <i class="el-icon-arrow-right icon"></i>
      </div>
    </div>
    <!-- 费用明细 -->
    <div class="fee-details">
      <div class="fee-item">
        <div class="fi-lf">
          <span>交易路径</span>
          <el-tooltip class="item" effect="dark" content="系统选取最低手续费的路径" placement="top">
            <img src="~@/assets/imgs/icon/tip.svg" alt="">
          </el-tooltip>
          <span>&nbsp;:</span>
        </div>
        <p v-if="defaultPath">
          <em>{{selectedCurrency}}</em>
           <img src="~@/assets/imgs/icon/jt.svg" alt="">
          <em>{{defaultPath.symbol}}</em>
            <img src="~@/assets/imgs/icon/jt.svg" alt="">
          <em>{{selectedCurrency}}</em>
        </p>
      </div>
      <div class="fee-item">
        <div class="fi-lf">
          <span>循环次数</span>
          <el-tooltip class="item" effect="dark" content="循环次数" placement="top">
            <img src="~@/assets/imgs/icon/tip.svg" alt="">
          </el-tooltip>
          <span>&nbsp;:</span>
        </div>
        <span>{{ tranNum }}次</span>
      </div>
      <div class="fee-item">
        <div class="fi-lf">
          <span>LP 池费用(0.01%)</span>
          <el-tooltip class="item" effect="dark" content="LP 池交易对自身收取的费用" placement="top">
            <img src="~@/assets/imgs/icon/tip.svg" alt="">
          </el-tooltip>
          <span>&nbsp;:</span>
        </div>
        <span>$ {{ $formatDecimals(lpFee) }}/次</span>
      </div>
      <div class="fee-item">
        <div class="fi-lf">
          <span>Gas 费用({{alphaFeePer}}%)</span>
          <el-tooltip class="item" effect="dark" content="合约费用" placement="top">
            <img src="~@/assets/imgs/icon/tip.svg" alt="">
          </el-tooltip>
          <span>&nbsp;:</span>
        </div>
        <div class="fi-rt">
          <span>$ {{ $formatDecimals(gasFee) }}/次</span>
        </div>
      </div>
    </div>

    <!-- 选择交易链路弹窗 -->
    <van-popup v-model:show="showChain" :style="{ width: '100%', height: '100vh' }">
      <div class="popup-chain-p">
        <div class="pc-title">
          <p class="icon">
            <i @click="closeChainPopup" class="el-icon-arrow-left"></i>
          </p>
          <span>交易路径</span>
        </div>
        <div class="popup-chain" v-if="tokenList">
          <ul class="chain-list" v-if="selectedPath">
            <li v-for="(item, index) in pathOptions" :key="index" @click="selectPath(item)">
              <div class='chain-logo'>
                <img class="logo" :src="item.imageUrl" alt="">
                <img class="chain" src="~@/assets/imgs/logo/WBNB.png" alt="">
              </div>
              <div class="chain-item">
                <div>
                  <p class="ci-coin">{{ item.symbol }}</p>
                  <div class="ci-fee">
                    <span>LP池费用: </span>
                    <em>{{ item.feePer }}</em>
                  </div>
                </div>
                <!--              <img v-if="selectedPath.symbol === item.symbol" src="~@/assets/imgs/icon/check1.svg" alt="">-->
                <img v-if="(tempSelectedPath && tempSelectedPath.symbol === item.symbol) || (!tempSelectedPath && selectedPath.symbol === item.symbol)" src="~@/assets/imgs/icon/check1.svg" alt="">
              </div>
            </li>
          </ul>
        </div>

        <div class="chain-confirm">
          <div class="ty-button" @click="confirmSelection">确认</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'selectChain',
  props:["isPopupMode","tokenList","tranNum","lpFee","gasFee","selectedCurrency","defaultPath","alphaFeePer"],
  data() {
    return {
      showChain: false,
      selectedPath: this.defaultPath,
      tempSelectedPath: null // 临时选择，确认前不会更新实际选择
    };
  },
  computed: {
    // 可选的路径列表
    pathOptions() {
      if(this.tokenList){
        return (this.tokenList.pathTokens) ? this.tokenList.pathTokens : [];
      }
      return [];
    }
  },
  watch: {
    defaultPath(newVal) {
      if (newVal) {
        this.selectedPath = newVal;
      }
    },
    tokenList(newVal) {
      if (newVal && newVal.pathTokens && newVal.pathTokens.length > 0) {
        // 如果tokenList变化且没有选择路径，则默认选择第一个
        if (!this.selectedPath) {
          this.selectedPath = newVal.pathTokens[0];
        }
      }
    }
  },
  methods: {
    // 显示选择链路弹窗
    showChainPopup() {
      this.showChain = true;
      this.tempSelectedPath = this.selectedPath;
    },

    // 关闭选择链路弹窗
    closeChainPopup() {
      this.showChain = false;
      this.tempSelectedPath = null;
    },

    // 选择路径
    selectPath(item) {
      this.tempSelectedPath = item;
    },

    // 确认选择
    confirmSelection() {
      if (this.tempSelectedPath) {
        this.selectedPath = this.tempSelectedPath;
        this.$emit('update:defaultPath', this.selectedPath);
        this.$emit('path-changed', this.selectedPath);
      }
      this.showChain = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.select-chain{
  border:0.5px solid $border;
  border-radius: 12px;
  margin-top: 8px;
  padding: 5px 15px 10px 15px;
}
.trade-path {
  padding: 15px 0 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;

  label {
    color: #000;
  }

  .trade-path-rt {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .logo {
      border-radius: 100%;
      width: 20px;
      height: 20px;
      object-fit: cover;
    }

    span{
      padding: 0 5px 0 5px;
    }
    .icon {
      width: 7px;
    }
  }
}

.fee-details {
  font-size: 12px;
  color: $color1;

  .fee-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 32px;
    border-bottom: 0.5px solid $border;
    box-sizing: border-box;

    &:last-child {
      border-bottom: none;
    }

    .fi-lf {
      display: flex;
      align-items: center;

      img {
        width: 13px;
        padding-left: 4px;
        cursor: pointer;
      }
    }
    .fi-rt{
      display: flex;
      align-items: center;
      img{
        display: block;
        width: 44px;
        border-radius: 4px;
      }
    }
    p{
      display: flex;
      align-items: center;
      img{
        margin: 0 8px;
      }
    }
  }
}
</style>